import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import ObjektListeSeite from './liste/ObjektListeSeite';
import ObjektSeite from './objekt/ObjektSeite';
import EinheitSeite from './einheit/EinheitSeite';
import { objektOrtAusPfad } from '../../../lib/immobilien/sidebarNav';

export interface Objekt {
  id: string;
  bezeichnung?: string;
  titel?: string;
  adresse?: string;
  strasse?: string;
  hausnummer?: string;
  plz?: string;
  stadt?: string;
  ort?: string;
  einheiten?: number;
  wohneinheiten?: number;
  anzahl_einheiten?: number;
  typ?: string;
  objekttyp?: string;
  status?: string;
  created_at?: string;
  baujahr?: number;
  wohnflaeche?: string;
  heizungsart?: string;
  eigentuemer?: string;
  zustaendig?: string;
  zustaendig_id?: string | null;
  zustaendig_typ?: string | null;
  profiles?: { full_name: string } | null;
  miete_soll?: string;
  letzte_pruefung?: string;
  energieklasse?: string;
  energieausweis?: string;
  onedrive_link?: string;
  objektnummer?: string;
  stellplatz_typ?: string;
  stellplatz_anzahl?: number;
  bild_url?: string;
}

interface ObjekteListeProps {
  onNavigateToMieter?: (id: string) => void;
  onNavigateToRechnung?: (id: string) => void;
  onNavigateToEigentuemer?: (id: string) => void;
  onNavigateToDokumente?: (objektId?: string) => void;
}

/**
 * Route /admin/objekte[/:id…] im neuen Design:
 * ohne :id die Objektliste (E2), sonst Übersicht (E3), Einheiten-Tab (E6) oder Einheit (E7).
 * Die frühere Detailansicht (ObjektDetailAlt) ist mit E9 entfallen – kein Pfad führte mehr dorthin.
 */
const ObjekteListe: React.FC<ObjekteListeProps> = ({ onNavigateToMieter }) => {
  const { id } = useParams<{ id: string }>();
  const { pathname } = useLocation();
  if (!id) return <ObjektListeSeite />;
  const ort = objektOrtAusPfad(pathname);
  if (ort?.bereich === 'einheiten' && ort.einheitId) {
    // key: beim Wechsel der Einheit schließt sich der offene Bereich
    return <EinheitSeite key={`${id}|${ort.einheitId}`} objektId={id} einheitId={ort.einheitId} onNavigateToMieter={onNavigateToMieter} />;
  }
  if (ort?.bereich === 'einheiten') return <ObjektSeite key={id} objektId={id} bereich="einheiten" />;
  return <ObjektSeite key={id} objektId={id} />;
};

export default ObjekteListe;
